'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EmbedWindow = exports.EmbedWindow = undefined;

exports.EmbedWindow = EmbedWindow = function EmbedWindow(c) {
    var appManager = c.appManager,
        uiManager = c.uiManager,
        instanceManager = c.instanceManager,
        i18n = c.i18nManager.get();

    var textArea = Ext.create('Ext.form.field.TextArea', {
        width: 700,
        height: 400,
        readOnly: true,
        cls: 'ns-textarea monospaced',
        value: uiManager.getEmbedHtml()
    });

    var window = Ext.create('Ext.window.Window', {
        title: i18n.embed_in_web_page,
        layout: 'fit',
        modal: true,
        resizable: false,
        items: textArea,
        destroyOnBlur: true,
        bbar: ['->', {
            text: i18n.select,
            handler: function handler() {
                textArea.selectText();
            }
        }],
        listeners: {
            show: function show(w) {
                uiManager.setAnchorPosition(w, 'favoriteButton');

                uiManager.enableRightClick();

                if (!w.hasDestroyOnBlurHandler) {
                    uiManager.addDestroyOnBlurHandler(w);
                }
            },
            hide: function hide() {
                uiManager.disableRightClick();
            }
        }
    });
    uiManager.reg(window, 'embedWindow');

    return window;
};
//# sourceMappingURL=EmbedWindow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/EmbedWindow.js
 ** module id = 166
 ** module chunks = 0 1
 **/